import { mutate } from 'swr';
import apiClient from '../../utils/axiosConfig';
import { useState, useEffect } from 'react';
import { useQuery } from '../../hook/useQuery';


export const useSerivePointTypes = () => {
    const [itemsPerPage, setPerPge] = useState(50)
    const [page, setPage] = useState(1)
    const { filterUrl } = useQuery();
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [allservicepointTypes, setAllServicePointTypes] = useState([]);
    const [servicepointTypes, setServicepointTypes] = useState([]);
    const [total, setTotal] = useState([]);
    const [lastPage, setLastPage] = useState([]);

    const fetchData = async () => {
        const queryString = filterUrl() || '';
        const url = `/servicepoint-type?perPage=${itemsPerPage}&page=${page}&${queryString}`;
        try {
            const response = await apiClient.get(url);
            await mutate(`/servicepoint-type?perPage=${itemsPerPage}&page=${page}&${queryString}`);
            setData(response?.data);
            setError(null);
        } catch (err) {
            setError(err.response?.data || 'An error occurred');
            setData(null);
        }
    };

    useEffect(() => {
        if (data?.data?.servicepoint_types?.data) {
            setServicepointTypes([...data?.data?.servicepoint_types?.data]);
            setTotal(data?.data?.servicepoint_types?.total);
            setLastPage(data?.data?.servicepoint_types?.last_page);
        }
    }, [data]);

    const fetchAllData = async () => {
        try {
            const response = await apiClient.get('/servicepoint-type')
            setAllServicePointTypes(response?.data)
        } catch (error) {

        }
    }

    const createSerivePointType = async (newData) => {
        try {
            const response = await apiClient.post('/servicepoint-type', newData);
            mutate(`/servicepoint-type?perPage=${itemsPerPage}&page=${page}`)
            return response.data
        } catch (err) {
            return err.response.data
        }

    };

    const updateSerivePointType = async (id, formData) => {
        try {
            const response = await apiClient.put(`/servicepoint-type/${id}`, formData);
            mutate(`/servicepoint-type?perPage=${itemsPerPage}&page=${page}`)
            mutate(`/servicepoint-type/${id}`)
            return response.data
        } catch (err) {
            return err.response.data
        }
    };

    const deleteSerivePointType = async (id) => {
        try {
            const response = await apiClient.delete(`/servicepoint-type/${id}`);
            mutate(`/servicepoint-type?perPage=${itemsPerPage}&page=${page}`)
            return response;
        } catch (err) {
            return err.response.data
        }
    };

    const getSerivePointTypeById = async (servicePoinTypeId) => {
        const response = await apiClient.get(`/servicepoint-type/${servicePoinTypeId}`);
        return response.data;
    };
    const getAll = async () => {
        try {
            const response = await apiClient.get(`/servicepoint-type`);
            mutate(`/servicepoint-type`);
            return Array.isArray(response?.data?.data?.servicepoint_types) ? response?.data?.data?.servicepoint_types : [];
        } catch (err) {
            return err.response.data;
        }
    }
    return {
        allservicepointTypes: Array.isArray(allservicepointTypes?.data?.servicepoint_types) ? allservicepointTypes?.data?.servicepoint_types : [],
        servicepointTypes,
        fetchAllData,
        isLoading: !error && !data,
        isError: error,
        itemsPerPage,
        lastPage,
        currentPage: page,
        total,
        setPage,
        fetchData,
        createSerivePointType,
        updateSerivePointType,
        deleteSerivePointType,
        getSerivePointTypeById,
        mutate,
        getAll,
        setPerPge
    };
};
